export default __webpack_public_path__ + "static/media/5_logistica.cfd34082.webp";